import Accordion from '../../../../shared/Accordion';

const Interests = ({
  open,
  onToggle,
  editable,
  thematicAreas,
  formDataArea,
  motivations,
  formDataUser,
  handleChange,
}) => {
  return (
    <Accordion
      id="intereses-motivacion"
      title="Intereses y motivación"
      open={open}
      onToggle={onToggle}
      edit={editable}
    >
      <div>
        <div className="mb-2">
          <label className="block text-xs sm:text-sm font-medium text-gray-700">
            ¿Qué áreas temáticas te interesan?
          </label>
          <span className="text-gray-400 text-[11px] sm:text-xs">
            (Selecciona mínimo 1)
          </span>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
          {thematicAreas.map((area) => (
            <label key={area.Id} className="flex items-start">
              <input
                type="checkbox"
                name="thematicAreas"
                value={area.Id}
                checked={Array.isArray(formDataArea) && formDataArea.includes(area.Id)}
                onChange={handleChange}
                disabled={!editable}
                className="shrink-0 h-5 w-5 rounded border-gray-300 accent-personalized"
              />
              <span className="ml-2 text-gray-700 text-xs sm:text-sm">
                {area.Name}
              </span>
            </label>
          ))}
        </div>
      </div>
      <div className="mt-4">
        <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-2">
          ¿Qué te motivó a unirte a la comunidad Esri?
          <span className="text-red-700"> *</span>
        </label>
        <select
          name="motivation"
          value={formDataUser.motivation}
          onChange={handleChange}
          disabled={!editable}
          className="w-full px-3 py-2 border border-gray-300 rounded text-sm"
          required
        >
          <option value="">
            {motivations.length ? 'Selecciona una opción' : 'Cargando...'}
          </option>
          {motivations.map((m) => (
            <option key={m.Id} value={m.Id}>
              {m.Name}
            </option>
          ))}
        </select>
      </div>
    </Accordion>
  );
};

export default Interests;
